export default __webpack_public_path__ + "static/media/hypnotic.b6469700.png";